declare global {
  interface Window {
    gtag: (...args: any[]) => void;
  }
}

export const GA_MEASUREMENT_ID = "G-XXXXXXXXXX";

export const trackPageView = (url: string) => {
  if (!window.gtag) return;

  window.gtag("config", GA_MEASUREMENT_ID, {
    page_path: url,
  });
};
export const setUserId = (userId: string) => {
  if (!window.gtag) return;

  window.gtag("config", GA_MEASUREMENT_ID, {
    user_id: userId,
  });
};

export const clearUserId = () => {
  if (!window.gtag) return;

  window.gtag("config", GA_MEASUREMENT_ID, {
    user_id: null,
  });
};

export const trackEvent = (eventName: string, params?: Record<string, any>) => {
  if (!window.gtag) return;

  window.gtag("event", eventName, params);
};
